import React from 'react';
import { FaLinkedin, FaInstagram, FaGithub } from 'react-icons/fa';
import { BiLogoGmail } from 'react-icons/bi';

import classes from './Home.module.css';
import backgroundImage from '../../assest/backgroundImage-pankaj.jpg';
import profileImage from '../../assest/profile-image-pankaj.jpg';

export default function Home() {
  return (
    <section id='home' className={classes['home-section']}>
      <div className={classes['home-background-image']}>
        <img
          src={backgroundImage}
          alt='background-image'
          style={{ maxWidth: '100%', borderRadius: '10px 10px 0px 0px' }}
        />
      </div>

      <div className={classes['home-intro']}>
        <div className={classes['profile-image']}>
          <img src={profileImage} alt='profile-image' style={{ width: ' 20%', borderRadius: '50%' }} />
        </div>

        <div className={classes['profile-intro']}>
          <h2 className={classes['profile-name']}>Pankaj Asiwal</h2>

          <div className={classes['dis-btn']}>
            <p className={classes['profile-dis']}>
              A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with
              JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks.
            </p>

            <div className={classes['resume-btn']}>
              <button>
                <a
                  target='_blank'
                  href='https://drive.google.com/file/d/1IxExopVrff4n8JNH2QMUpe8BfURimUUH/view?usp=sharing'
                >
                  Resume
                </a>
              </button>
            </div>
          </div>

          <div className={classes['social-handles']}>
            <a target='_blank' href='mailto:pankajasiwal11828@gmail.com'>
              <BiLogoGmail style={{ width: '1.5rem', height: '1.5rem' }} />
            </a>
            <a target='_blank' href='https://www.linkedin.com/in/pankaj-asiwal-a7611a1aa/'>
              <FaLinkedin style={{ width: '1.5rem', height: '1.5rem' }} />
            </a>
            <a target='_blank' href='https://github.com/pankajasiwal'>
              <FaGithub style={{ width: '1.5rem', height: '1.5rem' }} />
            </a>
            <a target='_blank' href='https://www.instagram.com/pankaj_asiwal05/'>
              <FaInstagram style={{ width: '1.5rem', height: '1.5rem' }} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
